import { CRUDService, CRUDServiceAPI2 } from './crud-service.class'

export class AvtosService extends CRUDService {
  subject = 'avtos'

  parse = (a) => {
    a.id = parseInt(a.id)
    a.bnorm = parseFloat(a.bnorm)
    a.ntr = parseFloat(a.ntr)
    return a
  }
}

export class AvtoServiceApiV2 extends CRUDServiceAPI2 {
  subject = 'avtos'

  parse = (a) => {
    a.id = parseInt(a.id)
    a.bnorm = a.bnorm ? parseFloat(a.bnorm) : 0
    a.ntr = a.ntr ? parseFloat(a.ntr) : 0
    a.volume = a.volume ? parseFloat(a.volume) : 0
    a.notop = a.notop ? parseFloat(a.notop) : 0
    a.vnomer = a.vnomer ? parseInt(a.vnomer) : 0
    a.weight = a.weight ? parseFloat(a.weight) : 0
    a.arenda = a.arenda ? parseFloat(a.arenda) : 0
    return a
  }

  toHtml(avto) {
    return (
      `${avto.nomer} ` +
      `<div class="comment">${avto.firm_info.full_name}</div>`
    )
  }

  getSearchFilters(term) {
    return { nomer: term }
  }

  getTraceReport(params = {}) {
    return this.$http({
      url: `${this.baseUrl}/${this.subject}/correct`,
      method: 'GET',
      responseType: 'blob',
    }).then((resp) => {
      this.FileSaver.saveAs(resp.data, `Местоположение автотранспорта.xlsx`)
    })
  }
}
